import styled from "styled-components";

const StyledContainer = styled.div`
  section {
    align-items: start;
    background: linear-gradient(0deg, #f5f9f9 0%, #f5f9f9 100%);
    border-radius: 12px;
    display: flex;
    justify-content: center;
    height: 240px;
    padding-top: 73px;
  }

  .container-message {
    background: #fff;
    border: 1px solid #cfe3fc;
    border-radius: 12px;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 16px 24px;
    text-align: center;
    width: 254px;

    h5 {
      color: #02494e;
      font-size: 16px;
      font-weight: 400;
      line-height: 150%;
      margin: unset;
    }
  }

  .ant-btn.ant-btn-sm {
    font-size: 12px;
    height: 24px;
    min-height: 24px;
  }
`;

export default StyledContainer;
